export default "__VITE_ASSET__DcKm4p9r__"